var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.777,
    height: 20.608,
    viewBox: "0 0 23.777 20.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75079",
    "data-name": "Group 75079",
    transform: "translate(-750 -482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M22.763,49.792a2.9,2.9,0,0,1,2.6-1.8c1.635-.006,3.27,0,4.906,0a3.028,3.028,0,0,1,.955.138,2.893,2.893,0,0,1,1.824,1.74c.152.428.288.862.435,1.292q1.712,0,3.425,0a2.9,2.9,0,0,1,2.872,2.872q0,5.82,0,11.641A2.9,2.9,0,0,1,36.854,68.6H19.318a5.046,5.046,0,0,1-.9-.043A2.9,2.9,0,0,1,16,65.678q0-5.822,0-11.643a2.9,2.9,0,0,1,2.874-2.873H22.3c.158-.456.3-.918.466-1.37m2.373-.18a1.312,1.312,0,0,0-.934.849c-.2.579-.385,1.16-.581,1.738a.794.794,0,0,1-.733.546c-1.356.009-2.712,0-4.067.006a1.313,1.313,0,0,0-1.234,1.283q0,5.821,0,11.643a1.318,1.318,0,0,0,.8,1.231,1.81,1.81,0,0,0,.788.106q8.869,0,17.738,0a1.314,1.314,0,0,0,1.281-1.284q.007-5.724,0-11.447a1.959,1.959,0,0,0-.054-.591,1.313,1.313,0,0,0-.892-.89,2.391,2.391,0,0,0-.691-.053H32.941a.8.8,0,0,1-.773-.514c-.162-.466-.313-.937-.471-1.4a2.4,2.4,0,0,0-.319-.735,1.311,1.311,0,0,0-1.062-.516q-2.4,0-4.806,0A1.626,1.626,0,0,0,25.137,49.613Z",
    transform: "translate(734 434.008)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M141.264,160.049a5.943,5.943,0,1,1-3.748,1.93,5.947,5.947,0,0,1,3.748-1.93m.1,1.586a4.359,4.359,0,1,0,2.659.5A4.342,4.342,0,0,0,141.366,161.635Z",
    transform: "translate(619.953 327.537)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M400.62,175.954a.792.792,0,1,1-.653.685A.8.8,0,0,1,400.62,175.954Z",
    transform: "translate(369.059 312.397)",
    fill: "#15803d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraActive);
export default __webpack_public_path__ + "static/media/CameraActive.b5682b8db15d82790ec6f361de3edcb2.svg";
export { ForwardRef as ReactComponent };